<template>
  <PageBreadcrumbs :items="breadcrumbs" />
  <ContentCard>
    <template #header>
      <ContentCardSubheader>
        {{ t('ProductLeads.title', { productName: product.title }) }}
        <template #actions>
          <div :id="exportActionTargetId" />
        </template>
      </ContentCardSubheader>
    </template>
    <LeadsDataProvider :contactable-id="product.globalId" :contactable-name="product.title" context="product" />
  </ContentCard>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import PageBreadcrumbs from '@/components/PageBreadcrumbs.vue'
import { exportActionTargetId } from '@/components/ReviewsCommon/Leads/exportActionTarget'
import LeadsDataProvider from '@/components/ReviewsCommon/Leads/LeadsDataProvider.vue'
import { useReviewsProductBreadcrumbs } from '@/composables/breadcrumbs/useReviewsProductBreadcrumbs'
import type { ProductById } from '@/gql/reviews'
import { useRoleRedirect } from '@/services/roleRedirect'
import ContentCard from '@/ui/ContentCard.vue'
import ContentCardSubheader from '@/ui/ContentCardSubheader.vue'

const props = defineProps<{
  product: ProductById
}>()

useRoleRedirect('viewReviewsProductLeads')

const { t } = useI18n()
const breadcrumbs = useReviewsProductBreadcrumbs(props.product)
</script>
